import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import {
  Button,
  Divider,
  Flex,
  Form,
  FormInstance,
  Select,
  Typography,
} from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { useEffect, useMemo, useState } from "react";
import {
  Schedule_Execution,
  Schedule_Execution_Step,
  Schedule_Step,
} from "../../../js/parsegenerated";

type Props = {
  execution?: Schedule_Execution;
  form?: FormInstance;
};

export default observer((props: Props) => {
  const t = useTranslation();
  const [steps, setSteps] = useState<Schedule_Step[]>([]);
  const [exeSteps, setExeSteps] = useState<Schedule_Execution_Step[]>([]);

  useEffect(() => {
    async function fetchSteps() {
      const fetchedSteps = await new Parse.Query(Schedule_Step).find();
      setSteps(fetchedSteps);
      if (props.execution) {
        const fetchedExeSteps = await new Parse.Query(Schedule_Execution_Step)
          .ascending("createdAt")
          .equalTo("scheduleexecution", props.execution)
          .find();
        setExeSteps(fetchedExeSteps);

        props.form?.setFieldsValue({
          steps: fetchedExeSteps.map((step) => step.id),
        });
      }
    }

    fetchSteps();
  }, []);

  const options = useMemo(() => {
    const stepOpt = steps.map((step) => ({
      label: step.description,
      value: step.id,
    }));
    const exeOptions = exeSteps.map((step) => ({
      label: step.description,
      value: step.id,
    }));
    stepOpt.push(...exeOptions);
    return stepOpt;
  }, [steps, exeSteps]);

  return (
    <Form.List name="steps">
      {(fields, operation, meta) => {
        return (
          <Flex gap="16px" vertical>
            {fields.map((field, index) => {
              return (
                <Flex
                  key={index}
                  justify="space-between"
                  align="flex-end"
                  gap="8px"
                >
                  <Form.Item
                    name={[field.name]}
                    key={field.name}
                    style={{ flexGrow: 1, marginBottom: 0 }}
                    label={t(
                      "maintenance:schedules.multi-source-schedule-modal.steps.count_index",
                      { index: index + 1 }
                    )}
                  >
                    <Select options={options} />
                  </Form.Item>
                  <Button onClick={() => operation.remove(index)} danger>
                    <Icon icon="fa:trash" />
                  </Button>
                </Flex>
              );
            })}

            {fields.length > 0 && <Divider />}

            <Typography.Text>
              {t(
                "maintenance:schedules.multi-source-schedule-modal.steps.button.add"
              )}
            </Typography.Text>
            <Select
              options={options}
              onSelect={(value) => operation.add(value)}
              value={""}
              style={{ width: "100%" }}
            />
          </Flex>
        );
      }}
    </Form.List>
  );
});
